import React from 'react';
import {useFieldArray, UseFieldArrayReturn} from 'react-hook-form';

type Props = {
   name: string;
   render: (params: UseFieldArrayReturn) => React.ReactNode;
};

const FieldArray = ({name, render}: Props) => {
   const props = useFieldArray<any>({
      name,
   });
   return <>{render(props)}</>;
};

export default FieldArray;
